export const DEFAULT_SERVER_SIDE_URL = 'api.datadome.co';
export const DEFAULT_CLIENT_SIDE_API_URL = 'https://api-js.datadome.co/js/';
export const DEFAULT_CLIENT_SIDE_SCRIPT_URL = 'https://js.datadome.co/tags.js';
export const DEFAULT_URI_REGEX_EXCLUSION =
    '\.(avi|avif|bmp|css|eot|flac|flv|gif|gz|ico|jpeg|jpg|js|json|less|map|mka|mkv|mov|mp3|mp4|mpeg|mpg|ogg|ogm|opus|otf|png|svg|svgz|swf|ttf|wav|webm|webp|woff|woff2|xml|zip)$';
export const DEFAULT_TIMEOUT = 150;
export const MODULE_NAME = 'Node.js-Nextjs';
export const MODULE_VERSION = '1.1.3';
